var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loaded)?_c('div',[_c('DefaultLayout')],1):_c('div',[_c('Spinner',{attrs:{"relative":false}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }